import culturesJson from './cultures.json';
import timezonesJson from './timezones.json';
const southAmericaTimezone = 'E. South America Standard Time';
const BUILDER_POSTMASTER = 'postmaster@builder.msging.net';
const timezones = timezonesJson.timezones;
export class ConfigurationsService {
    static $inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN'];
    constructor(MessagingHubService, MESSAGINGHUBDOMAIN) {
        this.MessagingHubService = MessagingHubService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
    }
    generateUri(owner, caller = undefined, name = undefined) {
        let uri = `lime://${owner}/configuration`;
        const params = new URLSearchParams();
        if (caller) {
            params.append('caller', caller);
        }
        if (name) {
            params.append('name', name);
        }
        if (params.toString()) {
            uri += `?${params.toString()}`;
        }
        return uri;
    }
    set(owner, configurations, caller = undefined, useConfigurationsApplication = false) {
        const uri = this.generateUri(owner, caller);
        const command = {
            method: 'set',
            uri: uri,
            type: 'application/json',
            resource: configurations,
        };
        if (useConfigurationsApplication) {
            command.to = `postmaster@configurations.${this.MESSAGINGHUBDOMAIN}`;
        }
        return this.MessagingHubService.sendCommand(command);
    }
    get(owner, caller = undefined, useConfigurationsApplication = false) {
        const uri = this.generateUri(owner, caller);
        const command = {
            method: 'get',
            uri: uri,
        };
        if (useConfigurationsApplication) {
            command.to = `postmaster@configurations.${this.MESSAGINGHUBDOMAIN}`;
        }
        return this.MessagingHubService.sendCommand(command);
    }
    async getSingle(owner, caller = undefined, name, useConfigurationsApplication = false) {
        const uri = this.generateUri(owner, caller, name);
        const command = {
            method: 'get',
            uri: uri,
        };
        if (useConfigurationsApplication) {
            command.to = `postmaster@configurations.${this.MESSAGINGHUBDOMAIN}`;
        }
        return await this.MessagingHubService.sendCommand(command);
    }
    getGateways(useConfigurationsApplication = false) {
        const command = {
            method: 'get',
            uri: '/configuration/gateways',
        };
        if (useConfigurationsApplication) {
            command.to = `postmaster@configurations.${this.MESSAGINGHUBDOMAIN}`;
        }
        return this.MessagingHubService.sendCommand(command);
    }
    delete(owner, caller = undefined, useConfigurationsApplication = false) {
        const uri = this.generateUri(owner, caller);
        const command = {
            method: 'delete',
            uri: uri,
        };
        if (useConfigurationsApplication) {
            command.to = `postmaster@configurations.${this.MESSAGINGHUBDOMAIN}`;
        }
        return this.MessagingHubService.sendCommand(command);
    }
    deleteSingle(owner, name, caller = undefined, useConfigurationsApplication = false) {
        const uri = this.generateUri(owner, caller, name);
        const command = {
            method: 'delete',
            uri: uri,
        };
        if (useConfigurationsApplication) {
            command.to = `postmaster@configurations.${this.MESSAGINGHUBDOMAIN}`;
        }
        return this.MessagingHubService.sendCommand(command);
    }
    getTimezoneByAccount(account) {
        const transformedTimezones = timezones.map((zone) => ({
            key: zone.value,
            name: zone.text,
            offset: zone.offset,
            utc: zone.utc,
        }));
        return transformedTimezones.find((zone) => zone.utc.includes(account.timeZoneName))
            || transformedTimezones.find((zone) => zone.key === southAmericaTimezone);
    }
    /**
     * @deprecated USE getTimezoneByAccount instead!
     */
    loadTimezones(account) {
        const timezones = timezonesJson.timezones.map((zone) => ({
            key: zone.value,
            name: zone.text,
            offset: zone.offset,
        }));
        const timezone = timezones.find((c) => c.key === account.timeZoneName) ||
            timezones.find((c) => c.key === southAmericaTimezone);
        return timezone;
    }
    async loadCulture(account) {
        const cultures = Object.keys(culturesJson).map((key) => ({ key, name: culturesJson[key].name }));
        const culture = cultures.find((c) => c.key === account.culture) ||
            cultures.find((c) => c.key === 'pt-BR');
        return culture;
    }
}
ConfigurationsService.$inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN'];
